import { Select, SelectOptionType } from '@octano/global-ui';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';
import { TranslationsKeys } from '../../../locales/translations';
import { useWarningsSummaryDetailsFormLoaderData } from '../loaders/StudentWarningsSummaryDetailsFormLoader';
import { useWarningsSummaryDetailsLoader } from '../loaders/StudentWarningsSummaryDetailsLoader';

const StudentWarningsSummaryDetailsFilters = () => {
  const { t } = useTranslation(TranslationsKeys.STUDENT_ALERTS_SUMMARY);
  const data = useWarningsSummaryDetailsFormLoaderData();
  const { query, updateQuery } = useWarningsSummaryDetailsLoader();

  const [currentYear, setCurrentYear] = useState<SelectOptionType>();
  const [currentPeriod, setCurrentPeriod] = useState<SelectOptionType>();

  const handleChangeYear = useCallback(
    (option: SelectOptionType) => {
      setCurrentYear(option);
      updateQuery({
        ...query,
        year: option.value.toString(),
      });
      window.history.replaceState(
        null,
        '',
        `/student-warnings/details/${query.studyPlanEnrollmentId}/${query.periodId}/${option.value}/${query.warningGroupType}`,
      );
    },
    [query, updateQuery],
  );

  const handleChangePeriod = useCallback(
    (option: SelectOptionType) => {
      setCurrentPeriod(option);
      updateQuery({
        ...query,
        periodId: option.value.toString(),
      });
      window.history.replaceState(
        null,
        '',
        `/student-warnings/details/${query.studyPlanEnrollmentId}/${option.value}/${query.year}/${query.warningGroupType}`,
      );
    },
    [query, updateQuery],
  );

  useEffect(() => {
    if (!currentYear && data?.years?.length) {
      const defaultYear = data.years.find(
        (year) => year.value.toString() === query.year,
      );
      setCurrentYear(defaultYear);
    }
  }, [currentYear, data?.years, query.year]);

  useEffect(() => {
    if (!currentPeriod && data?.periods?.length) {
      const defaultPeriod = data.periods.find(
        (period) => period.value.toString() === query.periodId,
      );
      setCurrentPeriod(defaultPeriod);
    }
  }, [currentPeriod, data?.periods, query.periodId]);

  if (!data) {
    return <></>;
  }

  return (
    <Container fluid>
      <Row className="pb-4 gutters-filters">
        <Col xs={12} md={4}>
          <Select
            name="year"
            value={currentYear}
            options={data?.years || []}
            label={t('filters.year.label')}
            placeholder={t('filters.year.placeholder')}
            onChange={handleChangeYear}
            isClearable={false}
            disabled={data?.years?.length < 1}
          />
        </Col>
        <Col xs={12} md={4}>
          <Select
            name="period"
            value={currentPeriod}
            options={data?.periods || []}
            label={t('filters.period.label')}
            placeholder={t('filters.period.placeholder')}
            onChange={handleChangePeriod}
            isClearable={false}
            disabled={data?.periods?.length < 1}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default StudentWarningsSummaryDetailsFilters;
